import type { DataSection } from '../../shared/api/contract.ts';
import {
  computeFreshness,
  dataAgeMs,
  FRESHNESS_POLICIES,
  type DataKind,
  type FreshnessStatus,
} from '../../shared/freshness/index.ts';

export const FRESHNESS_LABELS: Readonly<Record<FreshnessStatus, string>> = {
  live: 'À jour',
  recent: 'Récent',
  stale: 'Données anciennes',
  unavailable: 'Indisponible',
};

export function sectionFreshness(
  section: DataSection<unknown> | undefined,
  kind: DataKind,
  now: Date,
): FreshnessStatus {
  if (section === undefined) return 'unavailable';
  return computeFreshness(section.meta, section.data !== null, FRESHNESS_POLICIES[kind], now);
}

export function sectionAgeMs(section: DataSection<unknown>, now: Date): number | null {
  return dataAgeMs(section.meta, now);
}

/** « Données transport temporairement indisponibles. » : dire ce qui manque quand on le sait. */
export function unavailableMessage(section: DataSection<unknown> | undefined, subject?: string): string {
  if (section?.error?.code === 'not_configured') return 'Source pas encore connectée.';
  return subject === undefined
    ? 'Données temporairement indisponibles.'
    : `Données ${subject} temporairement indisponibles.`;
}
